import React, { useState } from "react";
import get from "lodash/get";
import { RadioPageOulu } from "../radio-page/radio-page-oulu";
import { RadioPagePori } from "../radio-page/radio-page-pori";
import { RadioPageLapua } from "../radio-page/radio-page-lapua";
import { RadioPageTurku } from "../radio-page/radio-page-turku";
import { RadioPageLohja } from "../radio-page/radio-page-lohja";
import { RadioPageLahti } from "../radio-page/radio-page-lahti";
import { RADIOT_CLICKED, RADIOT_TORNIO } from "../../store/actions";
import { RadioPageTornio } from "../radio-page/radio-page-tornio";
import { RadioPageKajani } from "../radio-page/radio-page-kajani";
import { ResponsiveImage } from "@quintype/components";
import { useDispatch, useSelector } from "react-redux";
import { RadioPageHelsinki } from "../radio-page/radio-page-helsinki";
import { RadioPageRovaniemi } from "../radio-page/radio-page-rovaniemi";
import { RadioPageKruunupyy } from "../radio-page/radio-page-kruunupyy";
import { RadioPageYleisohjelma } from "../radio-page/radio-page-yleisohjelma";
import { RadioPageKristiinankaupunki } from "../radio-page/radio-page-kristiinankaupunki";
import { useEffect } from "react";

const RadioPohjanmaPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: RADIOT_TORNIO,
      isRadiotTornioClicked: true,
    });
  }, [dispatch]);

  const style = `
    .channel-specific-radio-image {
      height: 50px;
      width: 50px;
      background: #a20d39;
      border-radius: 10px;
      padding:5px;
      margin: 5px;
    }

    .channel-specific-button {
      background:#a20d39;
      border:none;
      border-radius:10px;
      color: #fff;
      cursor: pointer;
      padding:10px;
      font-size:20px;
      margin: 5px;
    }

    .channel-specific-buttons-wrapper {
      display: flex;
      justify-content: center;
    }

    .top-banner-static-image {
      margin: 20px 0;
      text-align: center;
      position: relative;
      height: 675px;
    }
    .top-banner-static-image img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .radio-container {
      color: #FFF;
      margin: 100px 20px 20px 20px;
    }

    .radio-container h2, .static-page-container h3 {
      margin-top: 2rem !important;
      color: #a20d39;
    }

    .radio-container p {
      margin: 0.5rem 0 !important;
      font-size: 18px;
    }

    .radio-container h3 {
      font-size: 22px !important;
    }

    .radio-container a {
      color: #a20d39;
      font-weight: bold;
    }

    .custom-hero-container {
      position: relative;
      text-align: center;
      color: white;
      background-image: url("/assets/Pohjanmaa-hero.jpg");
      background-size: cover;
      background-position: center;
      height: 500px;
      margin-bottom: 20px;
    }

    .custom-hero-heading {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: 0;
      font-size: 2em;
    }

    .location-img {
      text-align: center;
    }

    .mhz {
      text-align: right;
      color: #a20d39;
      margin: 10px;
    }

    .map-hero-container {
      margin-top: 20px;
      position: relative;
      text-align: center;
      color: white;
      background-image: url("/assets/Pohjanmaa-web.jpg");
      background-size: cover;
      background-position: center;
      height: 600px;
    }

    .portrait-mobile-image {
      display: none;
    }

    .custom-hero-heading h3 {
      font-size: 30px  !important;
    }
    .custom-hero-heading p {
      font-size: 22px  !important;
    }

    .main-headline-content {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
   }

    @media screen and (max-width: 767px) {
      .custom-hero-container {
        background-image: url("/assets/Pohjanmaa-heromobiili.jpg");
      }
      .map-hero-container {
        background-image: url("/assets/Pohjanmaa-mobile.jpg");
        background-position: bottom center;
      }
      .big-desktop-image {
        display: none;
      }
      .portrait-mobile-image {
        display: block;
      }
      .contact-item {
        width: 100% !important;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="radio-container">
        <div className="main-headline-content">
          <div>
            <h1>Radio Dei Pohjanmaa</h1>
            <p>Enemmä toivoo</p>
          </div>
          <div className="mhz">
            <h2>Pohjanmaa / 98.4 MHz</h2>
          </div>
        </div>

        <div className="top-banner-static-image">
          <div className="custom-hero-heading">
            <h3>
              Radio Dei Pohjanmaa
            </h3>
            <p>Uskoa, toivoa ja yhteyttä kaupungista lakeuksille.</p>
          </div>
          <img src="/assets/Pohjanmaa-hero.jpg" className="big-desktop-image"/>
          <img src="/assets/Pohjanmaa-heromobiili.jpg" className="portrait-mobile-image"/>
        </div>

        <div>
          <h2>Radio Dei Pohjanmaa</h2>
          <p>Radio Dei Seinäjoki on pohjanmaan alueen taajuus. Alueella voi kuunnella valtakunnallisen radiolähetyksen ohella paikallisten luterilaisten seurakuntien jumalanpalveluksen suorana lähetyksenä joka sunnuntai klo 10 sekä myös arkijumalanpalveluksia. Maanantai-iltaisin kuuluu ajoittain myös paikallisia seurakuntaohjelmia klo 18.00-20.30 välillä.</p>
        </div>

        <div>
          <div>
            <h2>Kuuluvuusalue</h2>
            <p>
              Pohjanmaan taajuus kuuluu hyvin Kortesjärvelle, Kuortaneelle, Sydänmaalle, Koskenkorvaan, Isokyröön ja Vimpeliin, Alajärvelle, Vöyriin. Varsinkin autolla ja maastosta riippuen se voi kuulua hyvällä radiolla myös Kurikkaan, Jurvaan, Laihialle, Vähäkyröön, Oravaisille ja Uusikaarepyyhyn saakka.
            </p>
          </div>
        </div>

        <div>
          <div>
            <h2>Kuuluvuusaluekartta</h2>
            <p>Oheisesta kartasta näkyy suuntaa-antavasti Radio Dein Pohjanmaan kuuluvuusalue.</p>
          </div>
          <div className="map-hero-container">&nbsp;</div>
        </div>
      </div>
    </>
  );
}

export { RadioPohjanmaPage };
